import { render, staticRenderFns } from "./FileTypesCard.html?vue&type=template&id=42e63c86&"
import script from "./FileTypesCard.js?vue&type=script&lang=js&"
export * from "./FileTypesCard.js?vue&type=script&lang=js&"
import style0 from "./FileTypesCard.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports